export default __webpack_public_path__ + "static/media/logo1.634206da.png";